const initCounter = () => {
    const ks_counter_box = document.getElementById('counter-box');
    const ks_counter_elements = document.querySelectorAll('.count'); // counter elements

    const doTheCountingMagic = (el) => {
        const duration = 2000; // animation time in ms
        let start; // timestamp on first frame
        let final = parseInt(el.textContent, 10); // target number

        const step = ts => {
            if (!start) start = ts;
            let progress = (ts - start) / duration; // progress 0–1
            if (progress > 1) progress = 1;

            el.textContent = Math.floor(progress * final); // update number

            if (progress < 1) requestAnimationFrame(step);
        };

        requestAnimationFrame(step); // kick off animation
    };

    let counted = false;

    function isInViewPort(element) {
        let bounding = element.getBoundingClientRect();
        return (
            bounding.top >= 0 &&
            bounding.left >= 0 &&
            bounding.right <= (window.innerWidth || document.documentElement.clientWidth) &&
            bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight)
        );
    }

    window.addEventListener('scroll', () => {
        if (ks_counter_box && isInViewPort(ks_counter_box) && !counted) {
            ks_counter_elements.forEach(doTheCountingMagic);
            counted = true;
        }
    }, false);
};

export default initCounter;
